import React from 'react'
import { useMutation } from 'react-query'
import * as Sentry from '@sentry/react'
import { postNewsletterSignup } from '../api'
import Cookies from 'js-cookie'
import { ERROR_SIGNING_UP_FOR_NEWSLETTER } from '../errorConstants'

export const useNewsletterSignup = () => {
    const { mutate, mutateAsync, data, error, isLoading, isSuccess, isError } =
        useMutation(postNewsletterSignup, {
            onError: (error, context) => {
                const { recaptchaToken, ...restOfContext } = context || {}
                error.name = ERROR_SIGNING_UP_FOR_NEWSLETTER
                Sentry.captureException(error, {
                    extra: {
                        context: JSON.stringify(restOfContext, null, 2),
                    },
                    user: {
                        id: JSON.stringify(Cookies.get('GCG_CLIENT_USER_ID')),
                    },
                })
            },
        })
    return { mutate, mutateAsync, data, error, isLoading, isSuccess, isError }
}
